(ns quuppa.common.transit
  (:require [cognitect.transit :as transit]
            #?(:clj [linked.map :as lm]
               :cljs [linked.map :as lm :refer [LinkedMap]])
            #?(:clj [clojure.java.io :as io])
            #?(:cljs ["@js-joda/core" :refer [LocalDate Instant ZonedDateTime]])
            #?(:cljs ["@js-joda/timezone"]))
  #?(:clj (:import [java.io InputStream]
                   [java.time Instant ZonedDateTime LocalDate]
                   [linked.map LinkedMap]))
  (:refer-clojure :exclude [read]))

(def write-handlers
  {LinkedMap (transit/write-handler (constantly "linked/map") (fn [^LinkedMap v] (into [] v)))
   Instant (transit/write-handler (constantly "Instant") (fn [^Instant v] (.toString v)))
   LocalDate (transit/write-handler (constantly "LocalDate") (fn [^LocalDate v] (.toString v)))
   ZonedDateTime (transit/write-handler (constantly "ZonedDateTime") (fn [^ZonedDateTime v] (.toString v)))})

(def read-handlers
  {"linked/map" (transit/read-handler #(lm/->linked-map %))
   "Instant" (transit/read-handler #(. Instant parse %))
   "ZonedDateTime" (transit/read-handler #(. ZonedDateTime parse %))
   "LocalDate" (transit/read-handler #(. LocalDate parse %))
   ;; Also read default java.util.Dates #inst tag as Instant (e.g. from old QPE-next version)
   "m" (transit/read-handler #(. Instant ofEpochMilli %))})

(def transit-reader-type
  #?(:clj (if (System/getenv "Q_DEBUG")
            (do
              (println "Running in debug mode, using json-verbose for transit encoding")
              :json-verbose)
            :json))
  #?(:cljs (if goog/DEBUG
             (do
               (js/console.log "Running in debug mode, using json-verbose for transit encoding")
               :json-verbose)
             :json)))

#?(:clj (defn read-transit-stream [^InputStream is-body]
          (with-open [body is-body]
            (-> body
                (transit/reader :json {:handlers read-handlers})
                (transit/read)))))

(defn read [transit-val]
  #?(:clj
     (transit/read (transit/reader (io/input-stream transit-val) transit-reader-type {:handlers read-handlers})))
  #?(:cljs
     (transit/read (transit/reader transit-reader-type {:handlers read-handlers}) transit-val)))
